// Pure display helpers for a single calendar event.
//
// Extracted from `routes/CalendarEventDetail.tsx`, which sits on the project's
// known-debt list for AGENTS.md §3 #10's 15 KB route ceiling. That list is a
// ratchet — a baseline entry is a record of existing debt, not a licence to
// grow it — so adding a line to the route is only allowed by taking one out.
//
// These two have no state and no I/O, which is what makes them safe to lift out
// with no test churn: the detail page's own tests still exercise them through
// the page.

import type { CalendarEvent, CalendarItem, ItemOwner } from "@/lib/api/calendar";

const md = (d: Date): string => `${d.getMonth() + 1} 月 ${d.getDate()} 日`;

/** 「10 月 18 日 – 10 月 23 日 · 6 天」 — inclusive of both ends. */
export function formatRange(event: CalendarEvent): string {
  const s = new Date(`${event.start_date}T00:00:00`);
  if (!event.end_date) return md(s);
  const e = new Date(`${event.end_date}T00:00:00`);
  const days = Math.round((e.getTime() - s.getTime()) / 86_400_000) + 1;
  return `${md(s)} – ${md(e)} · ${days} 天`;
}

/**
 * Adapt a stored event into the view-item shape the editor already consumes,
 * so editing from the detail page needs no second editor variant.
 */
export function toEditorItem(event: CalendarEvent, me: string | undefined): CalendarItem {
  return {
    id: event.id,
    category: event.category as CalendarItem["category"],
    title: event.title,
    start_date: event.start_date,
    end_date: event.end_date,
    owner: (event.owner_id === me ? "me" : "partner") as ItemOwner,
    all_day: event.all_day,
    time: null,
    count: 1,
    source_type: event.source_type,
    source_id: event.source_id,
    recorded_by: event.recorded_by,
    recorded_by_name: null,
  };
}
